import { Modal, Row, Col, Form} from 'react-bootstrap';
import CommonService from '../../../services/CommonService';
import { toast } from 'react-toastify';
import 'react-datepicker/dist/react-datepicker.css';
import BaseService from '../../../services/BaseService';
import swal from 'sweetalert';

const DeleteElectionForm = (props) => {
    const {onModalClose, electionInfo} = props;


    const handleSubmit = (e) => {
        swal({
          title: "Are you sure?",
          text: "Deleting this Election data will delete it from the system and will not be recovered later.",
          icon: "warning",
          buttons: true,
          dangerMode: true,
        })
        .then((willDelete) => {
          if (willDelete) {
            var obj = {
              msgId: "null",
              sysId: null,
              opr: "deleteElectionData",
              hdrStruct: null,
              queryParam: null,
              reqData: { 
                "electionId" : electionInfo.electionId
              },
            };
        
            BaseService.processRequest(obj)
            .then((res) => res)
            .then((result) => {
              if (result.data.errors && result.data.errors.length > 0){
                toast.error(result.data.errors[0].message);
              } else {
                  toast.success("Issuer Association Deleted Successfully");
                  onModalClose();
              }
            })
          }
        });
                
    }

    return (
        
        <Modal show={true} backdrop="static" onHide={onModalClose}>
            <Modal.Header closeButton><h3>Delete Election</h3></Modal.Header>
            <Modal.Body>
            <form id="deleteElectionForm">
                <Row>
                    <Col>
                      <div className="control">
                           <label>Election Id: </label>
                            <Form.Control type="text" name="electionId" value={electionInfo.electionId} 
                            readOnly
                            />
                      </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                    <div className="control">
                           <label>Agency Name: </label>
                            <Form.Control type="text" name="issuerName" value={electionInfo.issuerName} 
                             readOnly
                            />
                      </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                     <div className="control">
                           <label>Type of Tax Debt: </label>
                            <Form.Control type="text" name="debtInstrumentName" value={electionInfo.debtInstrumentName} 
                            readOnly
                            />
                      </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                     <div className="control">
                           <label>Amount Text: </label>
                            <Form.Control as="textarea" rows={2} name="amtText" value={electionInfo.amtText} 
                            readOnly
                            />
                      </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                     <div className="control">
                           <label>Purpose: </label>
                            <Form.Control type="text" name="financePurposeName" value={electionInfo.financePurposeName} 
                            readOnly
                            />
                      </div>
                    </Col>
                </Row>
                <Row>
                    <Col md={4}>
                     <div className="control">
                           <label>Measure: </label>
                            <Form.Control type="text" name="measureName" value={electionInfo.measureName} 
                            readOnly
                            />
                      </div>
                    </Col>
                    <Col md={4}>
                     <div className="control">
                           <label>Yes Percentage: </label>
                            <Form.Control type="text" name="yesPct" value={electionInfo.yesPct} 
                            readOnly
                            />
                      </div>
                    </Col>
                    <Col md={4}>
                     <div className="control">
                           <label>No Percentage: </label>
                            <Form.Control type="text" name="noPct" value={electionInfo.noPct} 
                            readOnly
                            />
                      </div>
                    </Col>
                </Row>
                <Row>
                    <Col md={4}>
                     <div className="control">
                           <label>Result: </label>
                            <Form.Control type="text" name="resultCode" value={electionInfo.resultCode} 
                            readOnly
                            />
                      </div>
                    </Col>
                    <Col md={4}>
                     <div className="control">
                           <label>Threshold: </label>
                            <Form.Control type="text" name="thresholdValue" value={electionInfo.thresholdValue} 
                            readOnly
                            />
                      </div>
                    </Col>
                    <Col md={4}>
                     <div className="control">
                           <label>Election Year: </label>
                            <Form.Control type="text" name="electionYear" value={electionInfo.electionYear} 
                            readOnly
                            />
                      </div>
                    </Col>
                </Row>
                <Row>
                    <Col md={4}>
                     <div className="control">
                           <label>Election Type: </label>
                            <Form.Control type="text" name="electionType" value={electionInfo.electionType} 
                            readOnly
                            />
                      </div>
                    </Col>
                    <Col md={4}>
                     <div className="control">
                           <label>Election Date: </label>
                            <Form.Control type="text" name="electionDate" value={CommonService.dateFormatter(electionInfo.electionDate)} 
                            readOnly
                            />
                      </div>
                    </Col>
                </Row>
                <div className="btn-div">
                    <div className="fright">
                        <button type="button" className="custom-button-secondary  btn-secondary" onClick={onModalClose}>Cancel</button>{" "}
                        <button className="custom-button" type="button" onClick={(e)=>handleSubmit(e)}>Delete</button>
                    </div>
                </div>
            </form>
            </Modal.Body>
        </Modal>
        
    )
}

export default DeleteElectionForm
